import { sessionService } from '@/providers/services/auth/session';
import { USER_TYPE } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'users-component',
    components: {
        'roster-pages': () => import('@/components/rosters-pages/rosters-pages.vue'),
    },
})
export default class Users extends Vue {

    // --------------------------------------------------------
    // Properties

    private get session() {
        return sessionService.getSession();
    }

    private userTypeList: any = USER_TYPE;

    private userType: string = '';

    private rostersMenu: Array<{route: string, icon: string, label: string, isFileUpload?: boolean}> = [
        {
            route: '/users-rosters/roster-syncs',
            icon: 'dashboard',
            label: 'Dashboard',
        },
        {
            route: '/users-rosters/orgs',
            icon: 'corporate_fare',
            label: 'Organizations',
        },
        {
            route: '/users-rosters/schools',
            icon: 'school',
            label: 'Schools',
        },
        {
            route: '/users-rosters/users',
            icon: 'people',
            label: 'Users',
        },
        {
            route: '/users-rosters/classes',
            icon: 'class',
            label: 'Classes',
        },
        {
            route: '/users-rosters/roster-uploads',
            icon: 'cloud_upload',
            label: 'Uploads',
            isFileUpload: true,
        },
        {
            route: '/users-rosters/assign-school',
            icon: 'add_box',
            label: 'Assign School',
        },
    ];

    private activeRouteObj: any = null;

    // ----------------------------------------------------------------
    // Hooks

    private created() {
        this.userType = this.$access.getUserType();
        const isThirdPartyRoster = this.$access.isThirdPartyRoster;
        if (isThirdPartyRoster) {
            this.rostersMenu = this.rostersMenu.filter((item) => !item.isFileUpload);
        }
    }


    // ------------------------------------------------------------------
    // Actions

    private onSelectRoute(router: any) {
        this.activeRouteObj = router;
    }




    // ---------------------------------------------------------------------
    // Methods





}
